// @flow
import * as types from './types';

// export function transformFilterToRequestData(filter: types.Filter) {
export function transformFilterToRequestData(filter: any) {
  return {
    id: filter.id,
    isDeleted: filter.isDeleted,
    clientId: filter.clientId,
    filterItems: filter.filterItems,
  };
}

export function transformResponseToFilters(response: any) {
  return response.data.resources.map((data) => (
    types.mkFilter({
      id: data.id,
      clientId: data.clientId,
      isDeleted: data.isDeleted,
      filterItems: data.filterItems,
    })
  ));
}
